// flowgenIgnore
if (typeof window._ === 'undefined') {
  // eslint-disable-next-line
  const _ = require('underscore');

  window._ = _;
}

export default window._;



// WEBPACK FOOTER //
// ../globals/underscore.ts